import { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import AdminSidebar from '../AdminSidebar';
import { connect } from 'react-redux';
import { refresh, check_authenticated, load_user } from '../../../redux/actions/auth';
import { get_pedidos } from '../../../redux/actions/pedidos';
import { setSearchTerm } from '../../../redux/actions/productos'; 
import { useNavigate, useLocation } from 'react-router-dom';
import React from 'react';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { MEDIA } from '../../../styles/breakpoints';

const Layout = ({ 
    refresh, 
    check_authenticated, 
    load_user, 
    get_pedidos, 
    setSearchTerm, // Add this prop
    usuario, 
    children 
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isAdmin, setIsAdmin] = useState(false);
    // El sidebar se abre con la tira ❯ en escritorio y con el botón hamburguesa del navbar en
    // móvil y tablet; el estado vive acá porque lo usan los dos.
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const isCompact = useMediaQuery(MEDIA.tabletDown);

    useEffect(() => {
        // Cada página monta su propio Layout: la sesión se verifica solo mientras no haya un usuario
        // cargado (al abrir o recargar la app, o tras iniciar sesión), no en cada cambio de página.
        if (!usuario) {
            refresh();
            check_authenticated();
            load_user();
        }
        get_pedidos();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (usuario && usuario.tipo !== 'profesor') {
            setIsAdmin(true);
        }
    }, [usuario, navigate]);

    useEffect(() => {
        const searchPages = ['/carroproductos', '/ListaProductos'];
        if (!searchPages.includes(location.pathname)) {
            setSearchTerm('');
        }
    }, [location.pathname, setSearchTerm]);

    const handleSetSearchTerm = (term) => {
        setSearchTerm(term);
    };

    return (
        <>
            <Navbar
                setSearchTerm={handleSetSearchTerm}
                showMenuButton={isCompact}
                onMenuClick={() => setSidebarOpen(true)}
            />
            {isAdmin ? (
                <AdminSidebar open={sidebarOpen} setOpen={setSidebarOpen} showToggle={!isCompact} />
            ) : (
                <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} showToggle={!isCompact} />
            )}
            {children}
        </>
    );
};

const mapStateToProps = state => ({
    usuario: state.Auth.user
});
export default connect(mapStateToProps, {
    refresh,
    check_authenticated,
    load_user,
    get_pedidos,
    setSearchTerm,
})(Layout);